import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import TransitionDialog from 'components/TransitionDialog';

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: 10,
    padding: 18,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
  },

  paperFullWidth: {
    height: 120,
    width: '90%',
    margin: '320px auto 0',

    [theme.breakpoints.up('sm')]: {
      width: '60%',
    },

    [theme.breakpoints.up('lg')]: {
      width: '30%',
    },

    [theme.breakpoints.up('xl')]: {
      width: '20%',
    },
  },
}));

const TransactionInfoDialog = () => {
  const open = useModalOpen('Transaction Info');
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => dispatch(closeModal('Transaction Info'));

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      direction="up"
      desktopDirection="up"
      noCloseIcon
    >
      <p>
        This order came from a credit card, so please allow 48-72 hours for the funds to be
        available to cash out
      </p>
    </TransitionDialog>
  );
};

export default TransactionInfoDialog;
